module.exports = __webpack_public_path__ + "img/rc-back.352d25ba.png";